import { mailConstants } from '../actions/constants';

// eslint-disable-next-line
export default (
  state = {
    message: '',
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case mailConstants.SEND_MAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case mailConstants.SEND_MAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
      };
    case mailConstants.SEND_MAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return {
        ...state,
      };
  }
};
